import { render, staticRenderFns } from "./escuela-observadores-democraticos.vue?vue&type=template&id=5ee94903&scoped=true"
import script from "./escuela-observadores-democraticos.vue?vue&type=script&lang=js"
export * from "./escuela-observadores-democraticos.vue?vue&type=script&lang=js"
import style0 from "./escuela-observadores-democraticos.vue?vue&type=style&index=0&id=5ee94903&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ee94903",
  null
  
)

export default component.exports